
define('jst!conversations/chat/_show_more',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<ul class="navigation-container show-more-container">\n  <li class="show-more tooltip<%= count > 0 ? \' unread\' : \'\' %>" title="<%= translations.showMore %>">\n    <div class="wrapper">\n      <div class="unread-count"><%= count > 0 ? count : \'\' %></div>\n      <%- link_to(url, \' <div class="icon icon-24 icon-24-grey-three-dots"></div>\', { raw: true}) %>\n    </div>\n  </li>\n</ul>\n\n');
 });

